import { Link } from "react-router-dom";

export function Overline({ children, dark = false, className = "" }) {
  return (
    <span className={`text-xs font-semibold tracking-[0.25em] uppercase ${dark ? "text-cyan" : "text-brandblue"} ${className}`}>
      {children}
    </span>
  );
}

export function PrimaryLink({ to, children, dark = false, className = "", ...props }) {
  return (
    <Link
      to={to}
      className={`inline-flex items-center justify-center font-semibold text-sm px-6 py-3 rounded-sm transition-colors duration-300 ${
        dark ? "bg-cyan text-navy hover:bg-white" : "bg-navy text-white hover:bg-brandblue"
      } ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}

export function GhostLink({ to, children, dark = false, className = "", ...props }) {
  return (
    <Link
      to={to}
      className={`inline-flex items-center justify-center font-semibold text-sm px-6 py-3 rounded-sm border transition-colors duration-300 ${
        dark ? "border-white/25 text-white hover:bg-white/10" : "border-brandborder text-navy hover:border-brandblue hover:text-brandblue"
      } ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}

export function PageHero({ overline, title, subtitle }) {
  return (
    <section className="relative bg-navy text-white pt-36 pb-20 overflow-hidden grain-overlay">
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-brandblue/20 blur-[120px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 relative z-10">
        <Overline dark>{overline}</Overline>
        <h1 className="mt-5 font-heading font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.02]">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
